module.exports = __webpack_public_path__ + "static/media/41-8.c43a2820.mp3";